import { observable, action, decorate } from 'mobx';
import { BookingService } from '../../services/http';

export default class RatesAcknowledgementStore {
    signingUrl = null;
    signed = false;
    bookingId = null;
    history = null;
    isFetching = false;

    constructor(bookingStore) {
        this.bookingStore = bookingStore;
    }

    setHistory = history => {
        this.history = history;
    };

    // Set once DocuSign reports the signature. Stepping back into this step
    // afterwards has to offer a way forward: the signing_complete message has
    // already fired and will not fire again.
    markSigned = () => {
        this.signed = true;
    };

    init = () => {
        this.getSigningUrl();
    };

    getSigningUrl = async () => {
        const { bookingId } = this.bookingStore;

        // Reuse the envelope when re-entering the step, but only for the same
        // booking. Going back to Contact Details creates a new tenant and a new
        // booking, and the old envelope acknowledges the abandoned one.
        if (this.signingUrl && this.bookingId === bookingId) return;

        this.signingUrl = null;
        this.signed = false;
        this.bookingId = bookingId;

        this.isFetching = true;
        try {
            const response = await BookingService.getRatesAcknowledgement(bookingId);

            // A newer booking can take over while this is in flight: going back
            // to Contact Details and forward again starts a second request, and
            // the first is not cancelled. Whichever resolves last would win, so
            // a slow request for the abandoned booking could overwrite the
            // current envelope and have the tenant sign the wrong one.
            if (this.bookingId !== bookingId) return;

            if (response) {
                this.signingUrl = response.url;
            }
        } finally {
            // Only the current request owns the flag. A superseded one clearing
            // it would drop the spinner while the real request is still in
            // flight, rendering the iframe with no src. Cleared even on
            // failure, so re-entering the step can retry.
            if (this.bookingId === bookingId) {
                this.isFetching = false;
            }
        }
    };

    onSubmit = async () => {};
}

decorate(RatesAcknowledgementStore, {
    signingUrl: observable,
    signed: observable,
    bookingId: observable,
    history: observable,
    isFetching: observable,

    setHistory: action,
    markSigned: action,
    getSigningUrl: action,
});
